<template>
    <div class="pt-0 pb-12">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                <div class="grid grid-cols-10 gap-6 mb-6">
                    <div class="col-span-8">
                        <h2 class="font-semibold text-xl text-gray-800 leading-tight mt-2">
                            Copia e Cola
                        </h2>
                    </div>
                </div>
                <jet-form-section>
                    <template #description>

                        <div class="pt-0">
                            <p>Copie e cole o código PIX para realizar um pagamento.</p>
                        </div>

                    </template>

                    <template #form>
                        <div class="col-span-6 sm:col-span-6">
                            <jet-label for="key" value="Código PIX"/>
                            <jet-input id="key" :disabled="disablePixCode" class="mt-1 block w-full text-lg"
                                       v-model="form.pixCode"/>
                            <jet-input-error :message="form.error('pixCode')" class="mt-2"/>
                        </div>
                        <div class="grid grid-cols-6 col-span-6 gap-6" v-if="form.selected_account.key !== null">
                            <div class="col-span-6 sm:col-span-4">
                                <jet-label for="key" value="Chave"/>
                                <jet-input readonly id="key" type="text" class="mt-1 block w-full text-lg"
                                           v-model="form.selected_account.key"/>
                                <jet-input-error :message="form.error('selected_account.key')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="amount" value="Valor"/>
                                <jet-decimal :disabled="disabledAmount" id="amount" type="text"
                                             class="mt-1 block w-full text-lg" v-model="form.amount"/>
                                <jet-input-error :message="form.error('amount')" class="mt-2"/>
                            </div>
                            <div class="col-span-6">
                                <jet-label for="receiver" value="Favorecido"/>
                                <jet-input readonly id="receiver" type="text" class="mt-1 block w-full text-lg"
                                           v-model="form.contact.name"/>
                                <jet-input-error :message="form.error('selected_account.name')" class="mt-2"/>
                            </div>
                        </div>
                    </template>
                </jet-form-section>
                <jet-section-border class="py-2"/>
                <div class="grid grid-cols-1">
                    <div class="text-right" v-if="form.selected_account.key == null">
                        <button :disabled="form.processing" @click="checkCode()"
                                class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 py-3 px-6 rounded">
                            Verificar <i v-if="form.processing" class="fas fa-spin fa-spinner"/>
                        </button>
                    </div>
                    <div class="text-right" v-else>
                        <button @click="doCancel()"
                                class="bg-red-500 text-sm hover:bg-red-700 text-white text-base font-bold my-0 py-3 px-6 rounded">
                            Cancelar
                        </button>
                        <button @click="openReview()"
                                class="bg-blue-500 text-sm hover:bg-blue-700 text-white text-base font-bold my-0 py-3 px-6 rounded">
                            Transferir
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <jet-confirmation-modal :show="reviewTransfer" @close="reviewTransfer=false">
            <template #title>
                Confirme os dados
            </template>

            <template #content>

                <template>
                    <jet-section-border/>
                    <jet-form-section>
                        <template #title>
                            Dados da transação
                        </template>

                        <template #description>
                            Verifique se as informações estão corretas antes de finalizar a transferência.
                        </template>

                        <template #form class=" gap-0">
                            <div class="col-span-6 sm:col-span-6">
                                <table class="w-full">
                                    <template>
                                        <tr>
                                            <td class="px-2 py-2 text-sm" colspan="2">
                                            <span class="text-3xl font-extrabold">
                                                R$ {{ form.amount }}</span><br/>
                                                Para <span class="font-bold">{{ form.contact.name }}</span>
                                                <jet-input-error :message="form.error('amount')" class="mt-2"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-2 text-sm font-bold">Documento</td>
                                            <td class="px-2 py-2 text-sm text-right">
                                                {{ form.contact.federal_document || '' }}
                                            </td>
                                        </tr>
                                        <tr v-if="form.selected_account.type == 'PIX'">
                                            <td class="px-2 py-2 text-sm font-bold">Chave Pix</td>
                                            <td class="px-2 py-2 text-sm text-right">
                                                {{ form.selected_account.key || '' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-2 text-sm font-bold">Tipo transferência</td>
                                            <td class="px-2 py-2 text-sm text-right">
                                                PIX
                                            </td>
                                        </tr>
                                    </template>
                                </table>
                            </div>

                        </template>
                    </jet-form-section>
                    <jet-section-border/>
                    <jet-form-section>
                        <template #title>
                            Autenticação
                        </template>

                        <template #description>
                            Informe o código de autorização para autenticar sua solicitação
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-6">
                                <jet-label for="google_code" value="Código de Autorização"/>
                                <jet-input id="google_code" type="number" class="mt-1 block w-full"
                                           v-model="form.google_code"/>
                                <jet-input-error :message="form.error('google_code')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>
                </template>

            </template>

            <template #footer>
                <jet-secondary-button @click.native="reviewTransfer = false">
                    Agora não
                </jet-secondary-button>

                <jet-ok-button class="ml-2" @click.native="doPay()" :class="{ 'opacity-25': form.processing }"
                               :disabled="form.processing">
                    Confirmar
                </jet-ok-button>
            </template>
        </jet-confirmation-modal>
    </div>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';
import JetConfirmationModal from './../../Jetstream/ConfirmationModal';
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import JetFormSection from "../../Jetstream/FormSection";
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";
import JetInputError from "../../Jetstream/InputError";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetDecimal from "../../Jetstream/Decimal";

export default {
    components: {
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton,
        JetFormSection,
        JetLabel,
        JetInput,
        JetInputError,
        JetSecondaryButton,
        JetSectionBorder,
        JetDecimal
    },
    props: ['customer', 'errors'],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'POST',
                pixCode: null,
                amount: 0,
                contact: {
                    name: null,
                    federal_document: null,
                },
                transfer_type: {
                    name: 'PIX'
                },
                pix_type: null,
                qrcode_type: null,
                qrcode_read_type: null,
                selected_account: {
                    agency: null,
                    bank: {
                        id: null,
                        name: null
                    },
                    number: null,
                    key: null,
                    type: null
                },
                federal_document: null,
                goal: {
                    id: 99999,
                    name: "Outros"
                },
                google_code: null,
                receiver_code: null,
                description: null,
                backRoute: "pix.index"
            }, {
                resetOnSuccess: false,
            }),
            QRCodeData: null,
            reviewTransfer: false,
            disabledAmount: true,
            disablePixCode: false
        }
    },
    methods: {
        resetForm() {
            this.form.pixCode = null;
            this.disablePixCode = false;
            this.form.contact = {
                name: null,
                federal_document: null,
            };
            this.form.selected_account.key = null;
        },
        passQRCodeData(data) {
            this.form.amount = parseFloat(data.valor).toFixed(2);
            this.form.selected_account.key = data.chave;
            this.form.selected_account.type = 'PIX';
            this.form.receiver_code = data.idConciliacaoRecebedor;
            this.form.qrcode_type = data.tpQRCode;
            this.form.qrcode_read_type = data.codigoLeituraQRCode;
            this.form.description = data.informacoesAdicionais || null;
            if (parseFloat(data.valor) == 0) {
                this.disabledAmount = false;
            }
            this.form.contact = {
                name: data.nome,
                federal_document: data.documentoFederal
            };
            this.disablePixCode = true;
        },
        openReview() {
            let amount = this.form.amount.replace(".", "");
            amount = amount.replace(",", ".");
            if (parseFloat(parseFloat(amount)) == 0) {
                this.callToast('Informe o valor da operação.', 'error');
                return;
            }
            this.reviewTransfer = true;
            window.scrollTo(0, 0);
        },
        doPay() {
            this.form.post(`/transfer`, {
                preserveScroll: true,
                onError: (e) => {
                    this.form.processing = false;
                    this.$forceUpdate();
                },
                onSuccess: () => {
                    this.removeConfirm = false;
                    this.$forceUpdate();
                }
            });
        },
        doCancel() {
            this.resetForm();
        },
        checkCode() {
            if (!this.form.pixCode) {
                this.callToast('Informe o código PIX', 'error');
                return;
            }
            this.form.processing = true;
            fetch(`json/pix/qrcode/read?emv=${this.form.pixCode}`)
                .then(res => {
                    res.json().then(json => {
                        if (json.error) {
                            this.callToast(json.error, 'error');
                            this.resetForm();
                            return;
                        }
                        this.passQRCodeData(json);
                    });
                })
                .finally(() => {
                    this.form.processing = false;
                })
        },
        callToast(msg, type) {
            this.$toast.open({
                message: msg,
                type: type,
                duration: 5000,
                position: 'top-right'
            });
        }
    }
}
</script>
